<template>
  <div>
  <div v-if="isSelected&&!placedInGrid" class="highlight" :style="highlightStyle"></div>
  <div
    :style="pieceStyle"
    ref="pieceContainer"
    class="tetris-piece"
    v-on:mousedown="dragMouseDown"
    v-on:touchstart="dragMouseDown"
  >
  <div 
    class='tetris-block'
    :style="blockStyle"
  >
    <h3 class="block-title" :style="textStyle">{{title}}</h3>
  </div>
    <div class="render-container">
      <TetrisPieceRenderer
        :locked="isLocked"
        :piece-type="pieceType"
        :square-size="squareSize"
        :is-placed="placedInGrid"
        :event-reached="eventReached"
        @open-description="handleRendererClick"
      ></TetrisPieceRenderer>

    </div>
    <!-- The shape of the piece can be customized 
    <TetrisPieceRenderer
        v-bind="tPiece"
    ></TetrisPieceRenderer>
    
  <div class="lock-container"
      v-if="isLocked">
        <img src="../assets/art/locked_icon.png"/>
      </div>
    --> 
  </div>
    <DescriptionPopup
      :visible="descriptionVisible"
      :title="title"
      :description="description"
      :photo-name="photoName"
      :credit="credit"
      :photo-width="photoWidth"
      @close="closeDescription"
    ></DescriptionPopup>
    <MCQPopup
      :visible="MCQVisible"
      :title="title"
      :description="question"
      :answers="answers"
      @close="closeMCQ"
      @answered-correct="MCQAnsweredCorrectly">
    </MCQPopup>
  </div>
</template>

<script>

import DescriptionPopup from './DescriptionPopup.vue';
import MCQPopup from './MCQPopup.vue';
import TetrisPieceRenderer from './TetrisPieceRenderer.vue';

export default {
  name: "TetrisPiece",
  props: {
    squareSize: {
      type: Number,
      required: true,
    },
    getParentBoundingRect:{
      type:Function,
      required:true
    },
    hoveringOverGrid:{
      type:Boolean,
      default:false
    },
    allGridBoundingRects:{
      type:Array,
      default:()=>[]
    },
    eventIndex:{
      type:Number,
      default:0
    },
    gridLocation:{
      type:Object,
      default:()=>{return {x:0,y:0}}
    },
    gridRotation:{
      type:Number,
      default:0
    },
    pieceType:{
      type:String,
      default:"o"
    },
    title: {
      type:String,
      default:"Lorem Ipsum"
    },
    photoName:{
      type:String,
    },
    photoWidth:{
      type:Number,
    },
    description:{
      type:String,
    },
    question:{
      type:String,
    },
    answers:{
      type:Array,
    },
    eventReached:{
      type:Boolean,
      default:false
    },
    isSelected:{
      type:Boolean,
      default:false
    },
    credit:{
      type:String,
      default:null
    }

  },
  components:{
    TetrisPieceRenderer,
    DescriptionPopup,
    MCQPopup,
  },
  mounted(){
    window.addEventListener('keydown',this.handleKeyDown)
  },
  data() {
    return {
      // Track the current position of the piece
      position: { x: 0, y: 0 },
      dragPosition: {x: 0, y: 0},
      hasMoved:false,
      isLocked: true,
      descriptionVisible:false,
      MCQVisible:false,
      placedInGrid:false,
      initialMovePos:{x: 0, y: 0},
      isOverGrid:false,
      isHeld:false,
    };
  },
  computed: {
    pieceStyle() {
      let returnObj = {
        left: `${this.position.x}px`,
        top: `${this.position.y}px`,
      }
      switch(this.pieceType){
        case "o":
          returnObj.width = `${this.squareSize*2}px`;
          returnObj.height = `${this.squareSize*2}px`;
          break;
        case "t":
        case "z":
        case "j":
        case "l":
        case "s":
          returnObj.width = `${this.squareSize*3}px`;
          returnObj.height = `${this.squareSize*2}px`;
          break;
        case "i":
          returnObj.width = `${this.squareSize*4}px`;
          returnObj.height = `${this.squareSize*1}px`;
          break;

        default:
          //default is equivalent to o
          returnObj.width = `${this.squareSize*2}px`;
          returnObj.height = `${this.squareSize*2}px`;
          break;
      }
      if(this.placedInGrid && this.gridRotation){
        returnObj.rotate = `${this.gridRotation}deg`
      }
      if(this.placedInGrid){
        returnObj.pointerEvents='none'
      }
      return returnObj;
    },
    blockStyle(){
      let returnObj = {}
      switch(this.pieceType){
        case "o":
          returnObj.backgroundImage =  `url(${require('../assets/art/square02.png')})`
          returnObj.textAlign="center"
          returnObj.display='flex'
          returnObj.alignItems='center'
          break;
        case "t":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_t.png')})`

          break;
        case "z":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_z.png')})`
          break;
        case "s":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_s.png')})`
          returnObj.textAlign='right'
          break;
        case "j":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_j.png')})`
          break;
        case "l":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_l.png')})`
          returnObj.textAlign ='center'
          //returnObj.rotate = '-90deg'
          break;
        case "i":
          returnObj.backgroundImage =  `url(${require('../assets/art/blockshape_i.png')})`
          returnObj.backgroundSize = 'cover'
          returnObj.textAlign="center"
          returnObj.display='flex'
          returnObj.alignItems='center'
          returnObj.justifyContent='center'
          break;
      }
      return returnObj
    },
    textStyle(){
      let returnObj = {fontSize:`${this.squareSize/60}rem`}
      if(this.pieceType=='z'||this.pieceType=='s'){
        returnObj.width='66%'
        returnObj.textAlign='center'
      }
      if(this.pieceType=='s'){
        returnObj.marginLeft='33%'
      }
      if(!(this.pieceType=='o'||this.pieceType=='l')){
        returnObj.maxHeight='50%'    
      }

      return returnObj
    },
    highlightStyle(){
      let returnObj ={}
      switch(this.pieceType){
        case "o":
          returnObj.height = `${this.squareSize*2}px`;
          break;
        case "t":
        case "z":
        case "j":
        case "l":
        case "s":
          returnObj.height = `${this.squareSize*2}px`;
          break;
        case "i":
          returnObj.height = `${this.squareSize*1}px`;
          break;

        default:
          //default is equivalent to o
          returnObj.height = `${this.squareSize*2}px`;
          break;
      }
      
      return returnObj;
    
    },
    gridBoundingRect(){
      if(this.eventIndex>this.allGridBoundingRects.length-1){
        return new DOMRect();
      }
      return this.allGridBoundingRects[this.eventIndex]

    },
    

    
  },
  watch:{
    gridBoundingRect(){
      if(this.placedInGrid){
        //recalculate position
        const parentBoundingRect = this.getParentBoundingRect()
        this.position.x = this.gridBoundingRect.left+(this.gridLocation.x*this.squareSize) - parentBoundingRect.left
        this.position.y = this.gridBoundingRect.top+(this.gridLocation.y*this.squareSize) - parentBoundingRect.top
      }
    }
    
  },
  methods: {
    snapToGrid() {
      const snapX = Math.floor(this.position.x / this.squareSize) * this.squareSize;
      const snapY = Math.floor(this.position.y / this.squareSize) * this.squareSize;

      // Update the position to snap to grid
      this.position.x = snapX;
      this.position.y = snapY;
    },

    getEventPosition(e){
      if(e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
        var touch = e.touches[0] || e.changedTouches[0];
        return {x:touch.pageX,y:touch.pageY}
    } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
        return {x:e.clientX,y:e.clientY}
    }
    },

    dragMouseDown(e){
        console.log("mouse down")
        e.preventDefault();

        // set the element's new position:
        if(this.isLocked){
          //locked->description pop up unlocks
          this.descriptionVisible=true;
        }
        else{
          if (!this.placedInGrid){
            let boundingRect = this.$refs.pieceContainer.getBoundingClientRect();
            const parentBoundingRect = this.getParentBoundingRect()

            this.$refs.pieceContainer.style="position: absolute"
            this.$refs.pieceContainer.style.zIndex = 5
            this.$refs.pieceContainer.style.transform='scale(1.05)'

            this.position.x = boundingRect.left-parentBoundingRect.left
            this.position.y = boundingRect.top-parentBoundingRect.top
            console.log(this.position)
            this.initialMovePos.x = this.position.x
            this.initialMovePos.y = this.position.y
            this.$emit('toggle-grid-highlight')
            this.isHeld=true; 
            if(!e.key){
              // get the mouse cursor position at startup:
              let eventPos = this.getEventPosition(e);
              this.dragPosition.x = eventPos.x-this.position.x;
              this.dragPosition.y = eventPos.y-this.position.y;
              
              document.onmouseup = this.closeDragElement;
              document.ontouchend = this.closeDragElement;
              // call a function whenever the cursor moves:
              document.onmousemove = this.elementDrag;
              document.ontouchmove = this.elementDrag;
            }
            
          }

          
        }
    },

    calcIsOverGrid(){
      let boundingRect = this.$refs.pieceContainer.getBoundingClientRect();
       return( (boundingRect.left>=this.gridBoundingRect.left &&
              boundingRect.left<=this.gridBoundingRect.left+this.gridBoundingRect.width) ||
              (boundingRect.left+boundingRect.width>=this.gridBoundingRect.left &&
              boundingRect.left+boundingRect.width<=this.gridBoundingRect.left+this.gridBoundingRect.width)
          )
    },
    elementDrag(e) {
      if(e.key){
        switch(e.key){
          case "ArrowUp":
          case "w": 
            this.position.y-=20          
            break;
          case "ArrowDown":
          case "s":
            this.position.y+=20
            break;
          case "ArrowLeft":
          case "a":
            this.position.x-=20
            break;
          case "ArrowRight":
          case "d":
            this.position.x+=20
            break;
        }
      }
      else{
        //e.preventDefault();
        // calculate the new cursor position:
        let eventPos = this.getEventPosition(e)
        //console.log(`${eventPos.x}, ${eventPos.y}`)
        this.position.x =  eventPos.x-this.dragPosition.x;
        this.position.y =  eventPos.y-this.dragPosition.y;
        this.placedInGrid=false;
        } 
      //if manhattan distance of movement is greater than 20 pixels then the user intended to drag not click
      let manhattanDist = Math.abs(this.position.x-this.initialMovePos.x)+Math.abs(this.position.y-this.initialMovePos.y)
      if(manhattanDist>20 && !this.hasMoved){
        this.hasMoved=true
        
      }
      if(this.isOverGrid != this.calcIsOverGrid()){
        this.$emit('toggle-grid-hovering')
        this.isOverGrid=!this.isOverGrid
      }
      // set the element's new position:
      //console.log(this)
      //this.style.top = (this.offsetTop - this.position.y) + "px";
      //this.style.left = (this.offsetLeft - this.position.x) + "px";
      
        
    },

    closeDragElement(){
        /* stop moving when mouse button is released:*/
        if(this.gridBoundingRect){
          //if tetris piece top left corner is inside grid container
          if( this.isOverGrid){
              const parentBoundingRect = this.getParentBoundingRect()
              this.$refs.pieceContainer.style.transition = 'top 1s ease,left 1s ease, rotate 1s ease, scale 1s ease'
              this.position.x = this.gridBoundingRect.left+(this.gridLocation.x*this.squareSize) - parentBoundingRect.left
              this.position.y = this.gridBoundingRect.top+(this.gridLocation.y*this.squareSize) - parentBoundingRect.top
              this.placedInGrid = true
              console.log("piece-placed emitting")
              this.$emit("piece-placed")
              this.$emit('toggle-grid-hovering')
              this.isOverGrid=!this.isOverGrid
              setTimeout(
                    ()=>{
                        this.$refs.pieceContainer.style.zIndex=1;
                    },
                    1000
                )
            }
          else{
            console.log("dropping back in origin")
            console.log(`${this.eventIndex}`)
            //piece snaps back to container
            this.$refs.pieceContainer.style="position: static"
            this.position = { x: 0, y: 0 }
          }
        }
        //check if mouse moved between mouse down and up if not->click behavior
        if(!this.hasMoved){
          //click behavior->  info popup
            this.descriptionVisible=true
        }
        //need to turn off grid highlight
        this.$emit('toggle-grid-highlight')
        this.$refs.pieceContainer.style.transform='scale(1)'
        this.hasMoved=false;
        this.isHeld = false;
        document.ontouchend = null;
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchmove=null;
    },
    closeDescription(){
      this.descriptionVisible=false;
      this.isLocked=false;
    },
    closeMCQ(){
      this.MCQVisible=false;
    },
    MCQAnsweredCorrectly(){
      this.MCQVisible=false;
      this.isLocked=false;
    },
    handleRendererClick(){
      if(this.placedInGrid && !this.eventReached){
        this.descriptionVisible=true
      }
    },
    handleKeyDown(e){
      if(!this.isSelected && !this.descriptionVisible){return}
      if(!this.isHeld){
        switch(e.key){
          case "Enter":
          case " ":   
            console.log("picking up block");
            this.dragMouseDown(e)     
            break;

        }
      }
      else{
        switch(e.key){
          case "ArrowUp":
          case "w":           
          case "ArrowDown":
          case "s":
          case "ArrowLeft":
          case "a":
          case "ArrowRight":
          case "d":
            this.elementDrag(e)
            break;
          case "Enter":
          case " ":
            console.log("dropping block")
            this.closeDragElement()
            break;
          
        }
      }
      
    }
  },
};
</script>

<style scoped>
.tetris-piece {

  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transform-origin: left top;
  margin-bottom:25px;
}
.tetris-block {
  width: 100%;
  height: 100%;
  background-size: 100% 100%; /* Example: Block inside the piece */

}

.lock-container {
  position:absolute;
  background-color: rgba(50,50,50,0.25);
  width:inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items:center;
}

.lock-container img {
  width:30px;
}
.render-container {
  position:absolute;
  width:inherit;
  height: inherit;
}

.held {
  z-index: 5;
  transform:scale(1.1)
}
.block-title{
  font-size:1.4rem;
  line-height: 1;
  text-align: center;
}

.flip{
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
.highlight{
    background-color: rgba(200,200,200,0.3);
    width:100%;
    position:absolute;
    
    left:0px;
}
</style>
